module.exports = __webpack_public_path__ + "img/instagram.bfea8791.svg";